module.exports = __webpack_public_path__ + "img/shop_C_0.a94438c9.png";